<template>
  <!--添加问卷  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="AddList"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="标题" prop="title">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.title"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="主办单位" prop="organizer">
              <el-input
                placeholder="请输入内容"
                v-model="AddList.organizer"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否轮播" prop="isRotation">
              <el-select
                clearable
                placeholder="请选择"
                size="small"
                v-model="AddList.isRotation"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in newsStatus"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="地址" prop="address">
              <el-input
                placeholder="请输入地址"
                v-model="AddList.address"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="活动时间" prop="value1">
              <el-date-picker
                clearable
                end-placeholder="结束时间"
                range-separator="至"
                size="small"
                start-placeholder="开始时间"
                type="daterange"
                v-model="AddList.value1"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            label="封面图"
            prop="coverUrl"
            ref="coverUrl"
            class="shadow"
          >
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="upSuccess"
            >
              <img
                v-if="AddList.coverUrl"
                :src="AddList.coverUrl"
                class="avatar"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <!-- 内容区 -->
          <el-form-item
            label="内容"
            prop="content"
            style="width: 1000px"
            ref="contentext"
          >
            <el-upload
              :action="serverUrl"
              :before-upload="beforeUpload"
              :headers="header"
              :on-error="uploadError"
              :on-success="uploadSuccess"
              :show-file-list="false"
              :auto-upload="true"
              class="avatar-uploader2"
              name="img"
            ></el-upload>
            <quill-editor
              :options="editorOption"
              @change="onEditorChange($event)"
              ref="myTextEditor"
              style="width: 100%; height: 800px; padding-bottom: 100px"
              v-model="AddList.content"
            ></quill-editor>
            <div :visible.sync="videoUploadTag">
              <el-dialog
                :visible.sync="videoUploadTag"
                append-to-body
                id="video_upload"
                title="视频上传"
                width="100%"
              >
                <el-tabs style="margin-top: 0px">
                  <el-tab-pane label="添加视频链接" name="first">
                    <el-input
                      clearable
                      placeholder="请输入视频链接"
                      v-model="videoLink"
                    ></el-input>
                    <el-button
                      @click="addVideoLink()"
                      size="small"
                      style="margin: 20px 0px 0px 0px"
                      type="primary"
                      >添加</el-button
                    >
                  </el-tab-pane>
                  <el-tab-pane label="上传本地视频" name="second"
                    ><a-upload
                      list-type="picture"
                      :action="serverUrl"
                      name="img"
                      :headers="header"
                      :supportServerRender="true"
                      @change="videoChange"
                    >
                      <a-button> <a-icon type="upload" /> 上传视频 </a-button>
                    </a-upload></el-tab-pane
                  >
                </el-tabs>
              </el-dialog>
            </div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import VideoBlot from "../../utils/video.js";
import {baseURL} from "../../api/config";
Quill.register(VideoBlot);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["8px", "small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image", "video"], // 链接、图片、视频
];
export default {
  components: { quillEditor },
  data() {
    var self2 = this;
    var valiIcon = (rule, value, callback) => {
      // 图片验证

      if (this.AddList.coverUrl == "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false,
      videoUploadTag: false,
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      imgLoad: false, //加载load
      newsStatus: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      AudioUptImg: [], //图片上传
      //弹框插入的视频链接记录
      videoLink: "",
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      list: [],
      editorOption: {
        placeholder: "请输入...",
        theme: "snow",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  document.querySelector(".avatar-uploader2 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: function (value) {
                if (value) {
                  self2.videoUploadTag = true;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      //添加的参数：
      AddList: {
        title: "", //标题
        organizer: "", //主办单位
        coverUrl: "", //封面图
        isRotation: "", //是否轮播
        value1: "", //活动时间
        content: "", //内容
        address: "", //地址
      },
      toAdRule: {
        isRotation: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        organizer: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        address: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        value1: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        coverUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
      },
    };
  },
  methods: {
    upSuccess(file) {
      console.log(file, "-------------");
      this.AddList.coverUrl = file.entity;
      if (file.entity) {
        this.$refs.coverUrl.clearValidate();
      }
    },
    //提交成功：
    TopicSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
    //富文本图片上传前
    beforeUpload() {
      this.quillUpdateImg = true;
    },
    uploadSuccess(res, file) {
      console.log(file, "8888888");
      let quill = this.$refs.myTextEditor.quill;
      //如果上传成功
      if (res.statusCode == 200) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片 res.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.entity);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else if (!res.success && res.statusCode == "401") {
        // alert(res.message);
        this.$message.error(res.message);
        this.$router.push("/");
      } else if (res.success == false) {
        this.$message.error(res.message);
      }
      //loading动画消失
      this.quillUpdateImg = false;
    },
    //富文本编辑改变事件
    onEditorChange({ editor, html, text }) {
      //   console.log(html, "----");
      this.list.content = html;
    },
    // 上传本地视频
    videoChange(file, fileList, event) {
      this.insertEle("video", file.file.response.entity); //方法，插入图片到富文本
    },
    insertEle(type, url) {
      let quill = this.$refs.myTextEditor.quill;
      //  当编辑器中没有输入文本时，这里获取到的 range 为 null
      var range = this.$refs.myTextEditor.quill.getSelection();
      // 视频插入在富文本中的位置
      var index = 0;
      if (range == null) {
        index = 0;
      } else {
        index = range.index;
      }
      // 插入视频  response.data.url为服务器返回的图片地址
      if (type === "video") {
        this.$refs.myTextEditor.quill.insertEmbed(index, "simpleVideo", {
          url,
          controls: "controls",
          width: "100%",
          height: "200px",
          poster: url + "?x-oss-process=video/snapshot,t_1,f_jpg,m_fast",
        });
      }
      // 调整光标到最后
      this.$refs.myTextEditor.quill.setSelection(index + 1);
      this.videoUploadTag = false;
    },
    //富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
    // 添加视频
    addVideoLink(type) {
      if (this.videoLink.length == 0) {
        alert("请输入视频链接");
      }
      //当编辑器中没有输入文本时，这里获取到的 range 为 null
      var range = this.$refs.myTextEditor.quill.getSelection();
      //视频插入在富文本中的位置
      var index = 0;
      if (range == null) {
        index = 0;
      } else {
        index = range.index;
      }
      //隐藏弹框
      this.videoUploadTag = false;
      //将视频链接插入到当前的富文本当中
      ///以引号分隔嵌入的视频代码 如下图中有分析
      var list = this.videoLink;
      let data = list.split(" ");
      let obj = {};
      var str = "==";
      data.map((item) => (obj[item.split("=")[0]] = item.split("=")[1] || ""));
      var url = obj.src + str;
      var urlName = url.slice(1);
      this.$refs.myTextEditor.quill.insertEmbed(index, "video", urlName);
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/callup/insert", {
            title: this.AddList.title, //标题
            content: this.AddList.content, //内容
            startDate: this.AddList.value1[0], //开始时间
            endDate: this.AddList.value1[1], //结束时间
            coverUrl: this.AddList.coverUrl, //封面图
            organizer: this.AddList.organizer, //主办单位
            isRotation: this.AddList.isRotation, //是否轮播
            address: this.AddList.address, //地址
          }).then((res) => {
            if (res.success == true) {
              this.$router.push("/callUp");
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  created() {},
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    .shadow {
      /deep/ .el-upload {
        width: 200px;
        height: auto;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        outline: 0;
        border: 2px dashed #eee;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
    }

    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }

    /deep/ .el-upload-list--picture-card {
      margin: 0;
      display: inline;
      vertical-align: top;
      // display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
  }
}
/deep/.el-dialog {
  margin-top: 0 !important;
}
</style>